'use strict'

module.exports = (el) ->
  return false unless el?

  rect = el.getBoundingClientRect()

  return (
    rect.top >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  )
